import {Text} from 'platform/foundation';

import {isNotNil} from 'ramda';

import {Nullish} from 'shared/web';

const BULLET_PREFIX = '• ';

type FlagItem = {label: string; key?: string};

export const getFlagTooltipLabel = (labels: FlagItem[], selectedValue: string | Nullish) => {
  const items = labels.map((item) => item.label || item.key || null).filter(isNotNil);

  if (items.length === 0) {
    return null;
  }

  return (
    <>
      {items.map((item, index) => (
        <Text
          key={`${item}-${index}`} // eslint-disable-line react/no-array-index-key -- Pre-existing violation
          size="small"
          color={selectedValue === item ? 'success' : 'white'}
        >
          {BULLET_PREFIX}
          {item}
        </Text>
      ))}
    </>
  );
};
